import React, { useState } from 'react'

import AuthService from '../../utilities/services/auth.service'

import {
  createOrEditRole,
  createOrEditMember,
  emailValid,
} from '../../utilities/api'
import { formatMembers } from '../../utilities/helpers'
import {
  nameMatchesHiddenOrganizationRole,
  nameMatchesReservedAccountOwner,
  nameMatchesScannerOrganizationRole,
  filterVisibleTeamMembers,
} from './Roles/reservedRoleNames'

import { Roles } from './Roles'
import { Team } from './Team'

// wrapper for setting team management and sign up page
export default function TeamRoleWrapper({
  showRoles = true,
  showTeam = true,
  roles,
  updateRoles,
  members,
  updateMembers,
  permissions,
  sortRolesForSelect,
  organizationUUID,
}) {
  const { canManageTeam } = AuthService

  const [isCreating, setIsCreating] = useState(false)

  const [isInviting, setIsInviting] = useState(false)

  // create function that is a promise so button spinner works
  const createRoles = (data) => {
    return new Promise((resolve, reject) => {
      setIsCreating(true)
      createOrEditRole({ data })
        .then((res) => {
          updateRoles(res.data)
          setIsCreating(false)
          resolve()
        })
        .catch((err) => {
          console.error(err)
          setIsCreating(false)
          reject(err)
        })
    })
  }

  // create function that is a promise so button spinner works
  const inviteMember = (member) => {
    return new Promise((resolve, reject) => {
      // Invite lands in the org whose team is on screen, not the first membership
      createOrEditMember({ member, organizationUUID })
        .then((res) => {
          updateMembers(filterVisibleTeamMembers(formatMembers(res.data)))
          setIsInviting(false)
          resolve()
        })
        .catch((err) => {
          console.error(err)
          setIsInviting(false)
          reject()
        })
    })
  }

  return (
    <>
      {showRoles && (
        <Roles
          canManageTeam={canManageTeam()}
          roles={roles}
          permissions={permissions}
          createRoles={createRoles}
          updateRoles={updateRoles}
          isCreating={isCreating}
          sortRolesForSelect={sortRolesForSelect}
          nameMatchesReservedAccountOwner={nameMatchesReservedAccountOwner}
          nameMatchesScannerOrganizationRole={
            nameMatchesScannerOrganizationRole
          }
          nameMatchesHiddenOrganizationRole={nameMatchesHiddenOrganizationRole}
        />
      )}
      {showTeam && (
        <Team
          canManageTeam={canManageTeam()}
          members={members}
          updateMembers={updateMembers}
          roles={roles}
          inviteMember={inviteMember}
          emailValid={emailValid}
          isInviting={isInviting}
          setIsInviting={setIsInviting}
          nameMatchesReservedAccountOwner={nameMatchesReservedAccountOwner}
          nameMatchesHiddenOrganizationRole={nameMatchesHiddenOrganizationRole}
        />
      )}
    </>
  )
}
